import axios from '@/plugins/axios'

// Get a single tag
const getTag = async identifier => {
  try {
    const response = await axios.get(`tags/${identifier}`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

// Get list of tags
const getTags = async ({ search = null, page = 1 }) => {
  try {
    const params = {
      page: page
    }
    if (search) params.search = search
    const response = await axios.get('tags', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  getTag,
  getTags
}
